import { AdminMode } from 'swag-common/constants/admin.constants';
export const checkIsAdminMode = adminMode => {
  if (!adminMode) {
    return false;
  }
  return [AdminMode.CreatingCart, AdminMode.EditingCart].includes(adminMode);
};